import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'rect',
                attr: {
                    x: '1.5',
                    y: '2.39001',
                    width: '21',
                    height: '18.72',
                    fill: '#CFEFFF',
                },
            },
            {
                tag: 'rect',
                attr: {
                    x: '1.5',
                    y: '2.39001',
                    width: '21',
                    height: '1.56',
                    fill: '#5DC1F2',
                },
            },
            {
                tag: 'mask',
                attr: {
                    id: 'icon-0iyb0vwq4',
                    masktype: 'alpha',
                    maskUnits: 'userSpaceOnUse',
                    x: '0',
                    y: '8',
                    width: '24',
                    height: '4',
                },
                child: [
                    {
                        tag: 'path',
                        attr: {
                            d: 'M0.46875 8.63H23.3672L24 9.38563V11.2138H0V9.38563L0.46875 8.63Z',
                            fill: '#C4C4C4',
                        },
                    },
                ],
            },
            {
                tag: 'g',
                attr: { mask: 'url(#icon-0iyb0vwq4)' },
                child: [
                    {
                        tag: 'ellipse',
                        attr: {
                            cx: '4.80469',
                            cy: '9.2637',
                            rx: '1.42969',
                            ry: '1.6575',
                            fill: '#D8DEE2',
                        },
                    },
                    {
                        tag: 'ellipse',
                        attr: {
                            cx: '11.7188',
                            cy: '9.2637',
                            rx: '1.45312',
                            ry: '1.6575',
                            fill: '#D8DEE2',
                        },
                    },
                    {
                        tag: 'ellipse',
                        attr: {
                            cx: '18.75',
                            cy: '9.31245',
                            rx: '1.5',
                            ry: '1.70625',
                            fill: '#D8DEE2',
                        },
                    },
                    {
                        tag: 'ellipse',
                        attr: {
                            cx: '1.71094',
                            cy: '9.04439',
                            rx: '1.71094',
                            ry: '1.77937',
                            fill: '#45A9E3',
                        },
                    },
                    {
                        tag: 'ellipse',
                        attr: {
                            cx: '8.25',
                            cy: '9.02',
                            rx: '2.0625',
                            ry: '2.145',
                            fill: '#45A9E3',
                        },
                    },
                    {
                        tag: 'ellipse',
                        attr: {
                            cx: '15.1875',
                            cy: '9.04437',
                            rx: '2.0625',
                            ry: '2.16937',
                            fill: '#45A9E3',
                        },
                    },
                    {
                        tag: 'ellipse',
                        attr: {
                            cx: '22.1016',
                            cy: '9.01995',
                            rx: '1.89844',
                            ry: '1.95',
                            fill: '#45A9E3',
                        },
                    },
                ],
            },
            {
                tag: 'rect',
                attr: {
                    x: '3.75',
                    y: '12.53',
                    width: '9',
                    height: '4.72875',
                    fill: '#5DC1F2',
                },
            },
            {
                tag: 'rect',
                attr: {
                    x: '14.9531',
                    y: '12.53',
                    width: '5.29688',
                    height: '8.58',
                    fill: '#5DC1F2',
                },
            },
            {
                tag: 'mask',
                attr: {
                    id: 'icon-78esfeneg',
                    masktype: 'alpha',
                    maskUnits: 'userSpaceOnUse',
                    x: '0',
                    y: '4',
                    width: '24',
                    height: '6',
                },
                child: [
                    {
                        tag: 'path',
                        attr: {
                            d: 'M2.22656 4.72998H21.8203L24 9.40998H0L2.22656 4.72998Z',
                            fill: '#C4C4C4',
                        },
                    },
                ],
            },
            {
                tag: 'g',
                attr: { mask: 'url(#icon-78esfeneg)' },
                child: [
                    {
                        tag: 'path',
                        attr: {
                            d: 'M3.44531 10.3606L5.34375 4.48622L2.03906 4.33997L-0.351562 9.75122L3.44531 10.3606Z',
                            fill: '#79CBF3',
                        },
                    },
                    {
                        tag: 'path',
                        attr: {
                            d: 'M20.3438 9.6294L18.6562 4.4619L15.9844 3.99878L16.9453 9.6294H20.3438Z',
                            fill: '#EFF1F2',
                        },
                    },
                    {
                        tag: 'path',
                        attr: {
                            d: 'M6.51562 10.7263L7.80469 4.41314L5.01562 4.21814L3.30469 9.70251L6.51562 10.7263Z',
                            fill: '#EFF1F2',
                        },
                    },
                    {
                        tag: 'path',
                        attr: {
                            d: 'M10.4297 10.4094L10.7344 4.38878L7.54688 3.99878L6.14062 9.7269L10.4297 10.4094Z',
                            fill: '#79CBF3',
                        },
                    },
                    {
                        tag: 'path',
                        attr: {
                            d: 'M13.5469 10.0194L13.2188 4.3644L10.5938 3.99878L10.2891 9.80003L13.5469 10.0194Z',
                            fill: '#EFF1F2',
                        },
                    },
                    {
                        tag: 'path',
                        attr: {
                            d: 'M17.2969 9.60501L16.1016 4.36439L13.125 4.21814V9.60501H17.2969Z',
                            fill: '#79CBF3',
                        },
                    },
                    {
                        tag: 'path',
                        attr: {
                            d: 'M20.3672 9.79998L18.5625 4.19373L23.0156 4.8031L23.9766 8.16685L24.2578 9.55623L20.3672 9.79998Z',
                            fill: '#79CBF3',
                        },
                    },
                ],
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: false })) })));
};
const PvShowroomColored = React.forwardRef(IconComponent);
PvShowroomColored.displayName = 'PvShowroomColored';

export { PvShowroomColored };
